import api from "../api/axios";
import {
  CreateDivisionPayload,
  UpdateDivisionPayload,
} from "../Types/CompanyProfile/Division";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export const DIVISION_QUERY_KEY = ["divisions"];
export const VIEW_DIVISION_QUERY_KEY = ["view-divisions"];

export const divisionService = {
  createDivision: async (payload: CreateDivisionPayload) => {
    const response = await api.post(`api/divisions`, payload);
    return response.data;
  },
  updateDivision: async (id: number, payload: UpdateDivisionPayload) => {
    const response = await api.patch(`api/divisions/${id}`, payload);
    return response.data;
  },
  toggleStatus: async (id: number) =>
    requestWithRefresh(() =>
      api
        .patch(`api/divisions/${id}/toggle-status`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
  getAllViewDivision: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-divisions`, { headers: getAuthHeaders() })
        .then((res) => res.data),
    ),
  getAllViewDivisionById: async (id: number) =>
    requestWithRefresh(() =>
      api
        .get(`api/view-divisions/${id}`, { headers: getAuthHeaders() })
        .then((res) => res.data),
    ),
  getAllViewDivisionByCompany: async (code: string) =>
    requestWithRefresh(() =>
      api
        .get(`api/view-divisions/company/${code}`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
